export default {
  Funder: "funder",
  Dealer: "dealer",
  Cofunded: "cofunded"
};
